import { render, staticRenderFns } from "./DetalhamentoContrato.vue?vue&type=template&id=7b8d5370"
import script from "./DetalhamentoContrato.vue?vue&type=script&lang=js"
export * from "./DetalhamentoContrato.vue?vue&type=script&lang=js"
import style0 from "./DetalhamentoContrato.vue?vue&type=style&index=0&id=7b8d5370&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports